import { render, staticRenderFns } from "./ChipGroupCategory.vue?vue&type=template&id=8ba5caa0&"
import script from "./ChipGroupCategory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipGroupCategory.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ba5caa0')) {
      api.createRecord('8ba5caa0', component.options)
    } else {
      api.reload('8ba5caa0', component.options)
    }
    module.hot.accept("./ChipGroupCategory.vue?vue&type=template&id=8ba5caa0&", function () {
      api.rerender('8ba5caa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupCategory/ChipGroupCategory.vue"
export default component.exports